/* Shopify verifies the customer on every vault request. Only explicitly marked,
   same-provider studio/builder frames can request that customer's studio key. */
(() => {
  'use strict';
  if(window.EXOOloAccountBridge)return;window.EXOOloAccountBridge=true;
  const studioOrigins=new Set(['https://exo-partner-color-studies.tonyexo.chatgpt.site','https://exo-color.com']);
  function frameFor(source){
    return [...document.querySelectorAll('#olo-site-frame,iframe[data-olo-builder-frame][data-olo-account="exolox"]')].find(frame=>{
      if(frame.contentWindow!==source)return false;
      try{const url=new URL(frame.src);return studioOrigins.has(url.origin)&&(frame?.id==='olo-site-frame'?['/olo','/olo.html','/studio','/studio.html'].includes(url.pathname):url.pathname==='/olo-builder.html');}catch{return false;}
    });
  }
  const vaultType='olo-studio-access-v1';let queue=Promise.resolve();
  async function readJSON(url,options={}){
    const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
    if(response.status===401)return null;
    if(!response.ok)throw new Error('Your EXOLOX studio could not be loaded. Please try again.');
    return response.json();
  }
  async function account(){
    const profile=await readJSON('/pages/exo-color-studio?view=olo-account&_='+Date.now());
    if(!profile?.customerId)return null;
    if(!/^\d+$/.test(String(profile.customerId)))throw new Error('Please sign in to EXOLOX again.');
    const data=await readJSON('/apps/exo-projects/projects');if(!data)return null;
    const projectId='olo-studio-'+profile.customerId;
    let record=data.projects?.find(p=>p.id===projectId&&p.payload?.type===vaultType);
    if(!record){
      const bytes=crypto.getRandomValues(new Uint8Array(32)),key=[...bytes].map(n=>n.toString(16).padStart(2,'0')).join('');
      const response=await fetch('/apps/exo-projects/projects',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:projectId,name:'EXO Color Studio',expectedRevision:0,payload:{type:vaultType,key}})});
      if(response.status===401)return null;
      if(!response.ok&&response.status!==409)throw new Error('Could not connect your EXOLOX studio. Your drawing is still here.');
      // Read back the winner if two tabs initialize at once. Never use an
      // unconfirmed key, and never overwrite an existing studio credential.
      const saved=await readJSON('/apps/exo-projects/projects');
      record=saved?.projects?.find(p=>p.id===projectId&&p.payload?.type===vaultType);
    }
    if(!/^[a-f0-9]{64}$/.test(record?.payload?.key||''))throw new Error('Your studio connection needs attention. Please reload your EXOLOX account.');
    return {key:record.payload.key,name:profile.name||'My'};
  }
  window.addEventListener('message',event=>{
    if(!studioOrigins.has(event.origin))return;
    const frame=frameFor(event.source);
    const standalone=document.body.dataset.exoStudioConnect==='true'&&window.opener&&event.source===window.opener;
    if(!frame&&!standalone)return;
    const message=event.data;
    if(message?.type==='olo:fullscreen'&&frame?.id==='olo-site-frame'){
      document.documentElement.classList.toggle('olo-expanded',message.enabled===true);return;
    }
    if(message?.type!=='olo:account'||typeof message.id!=='string'||message.id.length>80)return;
    queue=queue.catch(()=>{}).then(async()=>{
      try{const value=await account();if(standalone?window.opener===event.source:frameFor(event.source)===frame)event.source.postMessage({type:'olo:account-result',id:message.id,account:value},event.origin);}
      catch(error){if(standalone?window.opener===event.source:frameFor(event.source)===frame)event.source.postMessage({type:'olo:account-result',id:message.id,error:error.message},event.origin);}
    });
  });
  document.getElementById('olo-site-expand')?.addEventListener('click',()=>document.getElementById('olo-site-frame')?.requestFullscreen?.());
})();
